import Router, { RawLocation } from "vue-router";
import { VueConstructor } from "vue";
import { EVENTS } from "@/lib/const";
import { Store } from "vuex";
import { RootState } from "@/store/types";
import { checkLoggedIn, getLoginData } from "@/lib/authHelper";
import emitter from "@/lib/helpers/emitter";

export default {
  install(Vue: VueConstructor, { router, store }: { router: Router; store: Store<RootState> }): void {
    router.beforeEach(async (to, from, next) => {
      let location: RawLocation | false | void;
      emitter.emit(EVENTS.STATUS_NOTIFICATIONS.HIDE_ALL);
      emitter.emit(EVENTS.LOADING.CHANGE, true);

      if (to.name !== "login" && (!store.state.loggedInUser || store.state.loggedInUser.id === "0") && getLoginData()) {
        try {
          await store.dispatch("setLogin", getLoginData());
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      let loggedIn = checkLoggedIn();
      const redirectPath = store.state.redirectPath || { path: "/" };
      to.matched.forEach(matchedRoute => {
        if (!matchedRoute.meta.public && !loggedIn) {
          store.commit("setRedirectPath", to);
          if (from.name !== "login") location = { name: "login" };
          else location = false;
        }
      });
      if (from.name === "login" && loggedIn && store.state.redirectPath !== null) {
        store.commit("setRedirectPath", null);
        location = redirectPath;
      }
      if (to.name === "login" && loggedIn) {
        location = { path: "/" };
      }

      if (to.name === "logout") {
        await store.dispatch("logout");
        location = { name: "login" };
      }

      if (to.name !== "login" && !to.meta.public && !loggedIn) {
        location = { name: "login" };
      }
      next(location);
    });
  },
};
